module.exports = __webpack_public_path__ + "img/lieve-tandarts-vierkant.9294153d.png";